module.exports = __webpack_public_path__ + "static/media/tags.92451d11.svg";